import { Map, Set, OrderedMap, fromJS } from 'immutable';

// Utils
import { getCurrentMoment, formatDate } from 'Shared/utils/DateTime.utils';

// Constants
import UserSuggestionsConstants from 'Shared/constants/UserSuggestions.constants';

const initialState = Map({
  [UserSuggestionsConstants.State.USER_SUGGESTIONS_BY_SLUG]: OrderedMap(),
  [UserSuggestionsConstants.State.USER_SUGGESTIONS_SLUGS_BY_DAY]: OrderedMap(),
});

export const UserSuggestionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UserSuggestionsConstants.Actions.FETCH_USER_SUGGESTIONS_SUCCESS:
    case UserSuggestionsConstants.Actions.UPDATE_USER_SUGGESTION_SUCCESS:
      return state
        .updateIn([UserSuggestionsConstants.State.USER_SUGGESTIONS_BY_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.userSuggestion).map(item => [
                item.attributes.slug,
                Map(fromJS(item.attributes)),
              ])
            )
          )
        )
        .updateIn(
          [UserSuggestionsConstants.State.USER_SUGGESTIONS_SLUGS_BY_DAY, formatDate(getCurrentMoment(), 'YYYY-MM-DD')],
          (existing = Set()) =>
            existing.merge(Object.values(action.payload.userSuggestion).map(item => item.attributes.slug))
        );
    default:
      return state;
  }
};
